import Banner from "./Banner";
import Careerabout from "./Careerabout";
import Oppening from "./Oppening";
import Cta from "./Cta";

const Career = ({ language }) => {
  return (
    <>
      <Banner language={language} />
      <Careerabout language={language} />
      <Oppening language={language} />
      <Cta language={language} />
    </>
  );
};

export default Career;